import { colors } from '@/styles/GlobalStyle';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  h1 {
    font-size: 34px;
    line-height: 41px;
    font-family: 'Exo 2';
    color: black;
    font-weight: 400;
  }

  @media (max-width: 1040px) {
    padding: 0 40px;
    align-items: center;
  }

  @media (max-width: 650px) {
    align-items: flex-start;

    h1 {
      margin-top: 20px;
    }
  }

  @media (max-width: 499px) {
    padding: 0 16px;
  }
`;

export const BreadCrumbsWrapper = styled.div`
  margin-top: 20px;

  &.mobile {
    display: none;
  }

  @media (max-width: 650px) {
    margin-top: 0;
    &:not(.mobile) {
      display: none;
    }

    &.mobile {
      display: block;
      color: ${colors.orange300};
      svg {
        color: ${colors.orange300};
      }
      cursor: pointer;
    }
  }
`;

export const BreadcrumbsContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 15px;
  align-items: center;

  a,
  p {
    font-size: 14px;
    font-family: 'Sora';
    line-height: 20px;
  }

  a {
    color: ${colors.gray800};
    cursor: pointer;
    transition: 0.2s ease-out;

    :hover {
      color: ${colors.orange300};
    }
  }

  svg {
    color: ${colors.gray600};
  }

  p {
    color: ${colors.orange300};
    font-weight: 700;
  }
`;
